// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ipis","actions":"styles_actions__h8b1S","error":"styles_error__EyQqF","message":"styles_message__2h4KV"};